module.exports = __webpack_public_path__ + "assets/images/key/key_hk_2021.svg?v=fe005b4a";